import React from "react";
import {
  Section, LinkedInGithub, EduRow, ExpBlock, Bullets, ProjectLink,
  SkillsTwoCol, Achievements,
} from "./shared";

const T = ({ children }) => <h2>{children}</h2>;

const Template4 = ({ data }) => (
  <div className="rt rt4">
    <div className="rt-header">
      <h1>{data.fullName}</h1>
      <p>{[data.email, data.phoneNo].filter(Boolean).join(" | ")}</p>
      {(data.linkedinId || data.githubId) && (
        <p><LinkedInGithub data={data} /></p>
      )}
      {data.location && <p>{data.location}</p>}
    </div>

    <Section
      title={<T>Career Objective</T>}
      items={[data.summary && <p>{data.summary}</p>]}
    />
    <Section
      title={<T>Skills</T>}
      items={[
        data.skills.length > 0 && (
          <SkillsTwoCol skills={data.skills} className="rt-grid" />
        ),
      ]}
    />
    <Section
      title={<T>Projects</T>}
      items={data.projects.map((p, i) => (
        <div key={i} className="rt-avoid rt-item">
          <h3>{p.projectName}</h3>
          <Bullets points={p.description} />
          <ProjectLink url={p.projectLink} />
        </div>
      ))}
    />
    <Section
      title={<T>Internship</T>}
      items={
        data.experiences.length
          ? data.experiences.map((x, i) => <ExpBlock key={i} exp={x} />)
          : [<p>Fresher</p>]
      }
    />
    <Section
      title={<T>Education</T>}
      items={data.education.map((e, i) => <EduRow key={i} edu={e} />)}
    />
    <Section
      title={<T>Certifications</T>}
      items={[data.others.length > 0 && <Achievements others={data.others} />]}
    />
  </div>
);

export default Template4;